import React, { useEffect } from "react";
import { Stack } from "@bookingcom/bui-react";
import { UnifiedPriceTagPriceBreakdown } from "./UnifiedPriceTagPriceBreakdown.js";
import { UnifiedPriceTagPricePerAdultExplanation } from "./UnifiedPriceTagPricePerAdultExplanation.js";
import { UnifiedPriceTagExplanation } from "./UnifiedPriceTagExplanation.js";
import useUserAgent from "../../../hooks/useUserAgent.js";
import usePriceConsistencyMonitoringEvents from "../../../hooks/c360/usePriceConsistencyMonitoringEvents.js";
import { UnifiedPriceTagMobile } from "./UnifiedPriceTag.mobile.js";
import { UnifiedPriceTagDesktop } from "./UnifiedPriceTag.desktop.js";
export const UnifiedPriceTag = (props) => {
    const { productId, price, priceAlignment, shouldShowPriceExplanationOnly, attachedAncillaries = [], pricePerAdult } = props;
    const { isMobile } = useUserAgent();
    const trackPriceConsistencyMonitoringEvents = usePriceConsistencyMonitoringEvents();
    useEffect(() => {
        if (productId) {
            trackPriceConsistencyMonitoringEvents("TAG", productId, [], price, pricePerAdult, attachedAncillaries);
        }
    }, [price, pricePerAdult, productId, trackPriceConsistencyMonitoringEvents, attachedAncillaries]);
    if (shouldShowPriceExplanationOnly) {
        return (React.createElement(Stack, { direction: "column", gap: 0, attributes: { "data-testid": "upt_container" } },
            React.createElement(Stack, { direction: "row", justifyContent: priceAlignment },
                React.createElement(UnifiedPriceTagPricePerAdultExplanation, { ...props }),
                React.createElement(UnifiedPriceTagPriceBreakdown, { ...props })),
            React.createElement(UnifiedPriceTagExplanation, { ...props })));
    }
    return isMobile ? React.createElement(UnifiedPriceTagMobile, { ...props }) : React.createElement(UnifiedPriceTagDesktop, { ...props });
};
